module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1193.21bc4e80.png";